<!-- Administration -->
<mdb-accordion-item>
  <mdb-accordion-item-head mdbWavesEffect>
    <jhi-bary-icon icon="user-plus" [faDirective]="FAS" class="fa-fw"></jhi-bary-icon>
    <span class="h6" jhiTranslate="sidebar.admin.title">Administration</span>
  </mdb-accordion-item-head>
  <mdb-accordion-item-body [customClass]="'overflow-auto'">
    <ul>
      <li>
        <a [routerLink]="PATHS.ADMIN_TOOLS.path" data-id-cypress="sidebar-admin-tools" routerLinkActive="active-link" jhiTranslate="sidebar.admin.tools" mdbWavesEffect> Tools </a>
      </li>
      <li>
        <a
          data-id-cypress="sidebar-client"
          [routerLink]="PATHS.ADMIN_USER_MANAGEMENT.path"
          routerLinkActive="active-link"
          jhiTranslate="sidebar.admin.userManagement"
          mdbWavesEffect
        >
          User management
        </a>
      </li>
      <li>
        <a [routerLink]="PATHS.ADMIN_MODERATOR_MANAGEMENT.path" routerLinkActive="active-link" jhiTranslate="sidebar.admin.moderatorManagement" mdbWavesEffect>
          Moderator management
        </a>
      </li>
      <li>
        <a
          [routerLink]="PATHS.ADMIN_IMPERSONATE_MANAGEMENT.path"
          routerLinkActive="active-link"
          data-id-cypress="sidebar-impersonate"
          jhiTranslate="sidebar.admin.impersonateManagement"
          mdbWavesEffect
        >
          Impersonate management
        </a>
      </li>
      <li>
        <a [routerLink]="PATHS.ADMIN_METRICS.path" routerLinkActive="active-link" jhiTranslate="sidebar.admin.metrics" mdbWavesEffect> Metrics </a>
      </li>
      <li>
        <a [routerLink]="PATHS.ADMIN_HEALTH.path" routerLinkActive="active-link" jhiTranslate="sidebar.admin.health" mdbWavesEffect> Health </a>
      </li>
      <li>
        <a [routerLink]="PATHS.ADMIN_CONFIGURATION.path" routerLinkActive="active-link" jhiTranslate="sidebar.admin.configuration" mdbWavesEffect> Configuration </a>
      </li>
      <li>
        <a [routerLink]="PATHS.ADMIN_LOGS.path" routerLinkActive="active-link" jhiTranslate="sidebar.admin.logs" mdbWavesEffect> Logs </a>
      </li>
      <li *ngIf="swaggerEnabled">
        <a [routerLink]="PATHS.ADMIN_DOCS.path" routerLinkActive="active-link" jhiTranslate="sidebar.admin.api" mdbWavesEffect> API </a>
      </li>
    </ul>
  </mdb-accordion-item-body>
</mdb-accordion-item>

<!-- Transporteurs -->
<mdb-accordion-item>
  <mdb-accordion-item-head mdbWavesEffect>
    <jhi-bary-icon icon="truck" [faDirective]="FAS" class="fa-fw"></jhi-bary-icon>
    <span class="h6" jhiTranslate="sidebar.transporter.title">Transporters</span>
  </mdb-accordion-item-head>
  <mdb-accordion-item-body [customClass]="'overflow-auto'">
    <ul>
      <li>
        <a [routerLink]="PATHS.ADMIN_TRANSPORTER_MANAGEMENT_DASHBOARD.path" routerLinkActive="active-link" jhiTranslate="sidebar.transporter.dashboard" mdbWavesEffect>
          Dashboard
        </a>
      </li>
      <li>
        <a [routerLink]="PATHS.ADMIN_NEW_SHOP.path" routerLinkActive="active-link" jhiTranslate="sidebar.transporter.createNewShop" mdbWavesEffect> Create a Transporter </a>
      </li>
      <li>
        <a [routerLink]="PATHS.ADMIN_TRANSPORTER_MANAGEMENT_IMPORT.path" routerLinkActive="active-link" jhiTranslate="sidebar.transporter.importTransporter" mdbWavesEffect>
          Import a Transporter
        </a>
      </li>
      <li *ngFor="let transporterOption of transporters; trackBy: trackById">
        <a routerLinkActive="active-link" [routerLink]="PATHS.ADMIN_TRANSPORTER_MANAGEMENT_ID_EDIT.path.replace(':id', transporterOption!.id!.toString())" mdbWavesEffect>
          {{ transporterOption.technicalName }}
        </a>
      </li>
    </ul>
  </mdb-accordion-item-body>
</mdb-accordion-item>

<!-- Modérateurs -->
<mdb-accordion-item>
  <mdb-accordion-item-head mdbWavesEffect>
    <jhi-bary-icon icon="user" [faDirective]="FAS" class="fa-fw"></jhi-bary-icon>
    <span class="h6" jhiTranslate="sidebar.moderator.title">Moderators</span>
  </mdb-accordion-item-head>
  <mdb-accordion-item-body>
    <mdb-accordion [multiple]="false" aria-multiselectable="false">
      <jhi-bary-sidebar-accordion-moderator (goToEvent)="handleGoTo($event)"></jhi-bary-sidebar-accordion-moderator>
    </mdb-accordion>
  </mdb-accordion-item-body>
</mdb-accordion-item>
